import { motion } from 'motion/react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import { Text } from '@components/ui-core/text/text'

import style from './scroll-indicator.module.scss'

const ScrollIndicator = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={style.scrollIndicator}
    >
      <Text as="span" className={style.scrollIndicatorText}>
        Scroll on
      </Text>
      <div
        className={style.scrollArrow}
        style={{
          backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-arrow-down.svg')})`,
        }}
      />
    </motion.div>
  )
}

export default ScrollIndicator
